import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LanguageService } from '../../language.service';
import { AuthService } from '../provider-service/auth.service';
import { HelperMethodService } from '../provider-service/helper-method.service';
import { MerchantServiceService } from '../provider-service/merchant-service.service';
import { SocialAuthService } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
declare var FB;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  lang;
  word;
  token;
  notifications: any = [];
  user: any = {};

  isOTPRequested: boolean = false;
  constructor(
    private language: LanguageService,
    private route: Router,
    private merchantServ: MerchantServiceService,
    private helperMethod: HelperMethodService,
    private _auth: AuthService,
    private authService: SocialAuthService
  ) {
    this.language.lang_beh.subscribe((val) => {
      this.lang = val;
    });

    this._auth.token_beh.subscribe((val) => {
      this.token = val;
      if (this.token) {
        this.user = JSON.parse(localStorage.getItem('user_data'));
      }
    });
    this._auth.user_data.subscribe((val) => {
      this.user = val;
    });
  }

  ngOnInit(): void {
    document.getElementById('all').addEventListener('click', () => {
      let doc = document.querySelectorAll(
        '.card_hover_login'
      )[0] as HTMLElement;
      console.log('doc in ngInits: ', doc);
      if (doc) {
        if (doc.classList.contains('showPop')) {
          doc.classList.remove('showPop');
        }
      }
      let docs = document.querySelectorAll(
        '.card_hover_login'
      )[1] as HTMLElement;
      console.log('doc in ngInitsss: ', docs);
      if (docs) {
        if (docs.classList.contains('showPop')) {
          docs.classList.remove('showPop');
        }
      }
    });

    // li
    let w = window.innerWidth;
    if (w < 768) {
      let items2 = Array.from(document.querySelectorAll('.navbar-nav'));
      items2.forEach((item) => {
        item.addEventListener('click', this.cmobileCloseMenueClick);
      });
    }
    //end .. to close menu when click in mobile version
    this.getNotification();
  }

  getNotification() {
    if (this.token) {
      // this._auth.getNotificationsListing().subscribe(
      //   (res: any) => {
      //     for (let i = 0; i <= 4; i++) {
      //       const element = res.detail.notifications[i];
      //       this.notifications.push(element);
      //     }
      //   },
      //   (err) => {
      //     if (navigator.onLine && err.status != 401) {
      //       this.helperMethod.presentToastr('Failed to load data.');
      //     }
      //   }
      // );
    }
  }

  cmobileCloseMenueClick() {
    let div = document.getElementById('navbarTogglerDemo01');
    div.classList.remove('show');
  }

  changeLang(event) {
    console.log('event language: ', event);
    if (event.target.checked == false) {
      this.lang = 'ar';
    } else {
      this.lang = 'en';
    }
    location.reload();
    this.language.changeLanguage(this.lang);
  }

  clickToggleLogin(s, e?) {
    if (e) e.stopPropagation();
    let doc = document.getElementById(s);
    if (s == 'loginUser_card_id') {
      document.getElementById('login_card_id').classList.remove('show');
    } else {
      document.getElementById('loginUser_card_id').classList.remove('show');
    }
    if (doc) {
      doc.classList.toggle('show');
    }
  }

  search(event) {
    let user_type = localStorage.getItem('user_type');
    if (user_type == 'merchant') {
      this.route.navigate([`/merchant/search/${event.search}`]);
    } else {
      this.route.navigate([`/user/categories`], {
        queryParams: {
          search: event.search,
        },
      });
    }
  }

  logOut() {
    localStorage.clear();
    this._auth.token_beh.next(null);
    this.route.navigate(['/']);
    this.notifications = [];
  }

  // merchant login
  LoginForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'),
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });
  get username() {
    return this.LoginForm.get('username');
  }
  get password() {
    return this.LoginForm.get('password');
  }

  login(s) {
    this.helperMethod.presentSpinner();
    this.merchantServ
      .login(this.LoginForm.value.username, this.LoginForm.value.password)
      .subscribe(
        (res: any) => {
          localStorage.setItem('bogo_token', res.access_token);
          this._auth.token_beh.next(res.access_token);
          this.helperMethod.hideSpinner();
          this.helperMethod.presentToastr('Login Successfully');
          // this.clickToggleLogin("login_card_id");
          // localStorage.setItem('branch_merchant', "JSON.stringify(res.branch)");
          localStorage.setItem('user_type', 'merchant');
          // this.clickToggleLogin('loginUser_card_id');
          this.route.navigate(['/merchant/home/']);
        },
        (err) => {
          this.helperMethod.hideSpinner();
          this.helperMethod.presentToastr('Login Failed, some error occur');

          console.log('err => ', err);
        }
      );
  }

  UserLoginForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$'),
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });
  userLogin(s) {
    if (!this.UserLoginForm.valid) {
      Object.values(this.UserLoginForm.controls).forEach((control: any) => {
        control.markAsTouched();
      });
    } else {
      this.helperMethod.presentSpinner();
      this._auth.login(s).subscribe(
        (res: any) => {
          this.helperMethod.hideSpinner();
          this.clickToggleLogin('login_card_id');
          localStorage.setItem('user_type', 'client');
          localStorage.setItem('user_data', JSON.stringify(res.user));
          this.clickToggleLogin('loginUser_card_id');

          if (res.token) {
            this.helperMethod.setHasPackage(res.user.have_package);
            // this.clickToggleLogin("login_card_id");
            if (res.user.verified == true) {
              this.helperMethod.presentToastr('Login Successfully');
              if (res.user.email && res.user.mobile) {
                this.route.navigate(['/user/home']);
              } else {
                this.route.navigate(['/user/editInfo']);
              }
            } else if (res.user.verified == false) {
              if (res.user.email && res.user.mobile) {
                this.route.navigate(['/verify-code']);
                this.helperMethod.presentToastr(
                  'Please verify your email first.'
                );
              } else {
                this.route.navigate(['/user/editInfo']);
              }
            }
          } else if (res.details) {
            this.helperMethod.presentToastr(res.details);
          }
        },
        (err) => {
          this.helperMethod.hideSpinner();
          this.helperMethod.presentToastr('Login Failed, some error occur');
        }
      );
    }
  }

  loginWithFb() {
    FB.login(
      (response) => {
        if (response.authResponse.accessToken) {
          this._auth
            .loginWithFacebook(response.authResponse.accessToken)
            .subscribe(
              (res: any) => {
                this.clickToggleLogin('login_card_id');
                this.clickToggleLogin('loginUser_card_id');

                localStorage.setItem('user_data', JSON.stringify(res.user));
                localStorage.setItem('user_type', 'client');

                if (res.user) {
                  this.helperMethod.setHasPackage(res.user.have_package);
                  if (res.user.verified == true) {
                    if (
                      res.user.mobile &&
                      res.user.email &&
                      res.user.email != res.user.key + '@bogo-plus.com'
                    ) {
                      this.route.navigate(['/user/home']);
                    } else {
                      this.route.navigate(['/user/editInfo']);
                    }
                  } else if (res.user.verified == false) {
                    if (
                      res.user.mobile &&
                      res.user.email &&
                      res.user.email != res.user.key + '@bogo-plus.com'
                    ) {
                      this.helperMethod.presentToastr(
                        'Please verify your email first.'
                      );
                      this.route.navigate(['/user/verify-code']);
                    } else {
                      this.route.navigate(['/user/editInfo']);
                    }
                  }
                } else if (res.details) {
                  this.helperMethod.presentToastr(res.details);
                } else {
                  this.helperMethod.presentToastr(
                    'Failed to login with Facebook.'
                  );
                }
              },
              (err) => {
                if (navigator.onLine && err.status != 401) {
                  if (err && err.detail[0]) {
                    this.helperMethod.presentToastr(err.detail[0]);
                  } else {
                    this.helperMethod.presentToastr(
                      'Failed to login with Facebook.'
                    );
                  }
                }
              }
            );
        }
      },
      { scope: ['public_profile', 'email'] }
    );
  }

  signInWithGoogle(): void {
    this.authService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then((res1: any) => {
        this.helperMethod.presentSpinner();
        this._auth.loginWithGoogle(res1.authToken).subscribe(
          (res: any) => {
            this.helperMethod.hideSpinner();
            localStorage.setItem('user_data', JSON.stringify(res.user));
            localStorage.setItem('user_type', 'client');

            if (res.token) {
              this.helperMethod.presentToastr('Login');
              this.helperMethod.setHasPackage(res.user.have_package);

              if (res.user.verified == true) {
                if (res.user.email && res.user.mobile) {
                  this.route.navigate(['/user/home']);
                } else {
                  this.route.navigate(['/user/editInfo']);
                }
              } else if (res.user.verified == false) {
                if (res.user.email && res.user.mobile) {
                  this.route.navigate(['/user/verify-code']);
                  this.helperMethod.presentToastr(
                    'Please verify your email first.'
                  );
                } else {
                  this.route.navigate(['/user/editInfo']);
                }
              }
            } else if (res.details) {
              this.helperMethod.presentToastr(res.details);
            }
          },
          (err) => {
            this.helperMethod.hideSpinner();
            if (err.error.error) {
              this.helperMethod.presentToastr(err.error.error);
            } else if (err.error.detail) {
              this.helperMethod.presentToastr(err.error.detail);
            } else {
              this.helperMethod.presentToastr(
                'Some thing work wrong ,Please try again later'
              );
            }
          }
        );
      })
      .catch((err) => {
        this.helperMethod.hideSpinner();
        this.helperMethod.presentToastr(
          'Some thing work wrong ,Please try again later'
        );
      });
  }

  UserLoginRequest = new FormGroup({
    phone: new FormControl('', [Validators.required]),
    otp: new FormControl(''),
  });

  requestLogin(data) {
    if (!this.UserLoginRequest.valid) {
      this.UserLoginRequest.controls['phone'].markAsTouched();
      this.isOTPRequested &&
        this.UserLoginRequest.controls['otp'].markAsTouched();
    } else {
      if (this.isOTPRequested) {
        this.helperMethod.presentSpinner();
        this._auth.requestLogin(data).subscribe(
          (res: any) => {
            this.helperMethod.hideSpinner();
            this.clickToggleLogin('login_card_id');
            this.clickToggleLogin('loginUser_card_id');
            localStorage.setItem('user_type', 'client');
            this.route.navigate(['/user/home']);
            this.UserLoginRequest.controls['phone'].setValue('');
            this.UserLoginRequest.controls['otp'].setValue('');
            this.isOTPRequested = false;
          },
          (err) => {
            this.helperMethod.hideSpinner();
            this.clickToggleLogin('login_card_id');
            this.clickToggleLogin('loginUser_card_id');
            if (err.error.non_field_errors) {
              this.helperMethod.presentToastr(err.error.non_field_errors[0]);
            } else {
              this.helperMethod.presentToastr('Something went wrong');
            }
          }
        );
      } else {
        //  requestLoginOTP
        this.helperMethod.presentSpinner();
        this._auth.requestLoginOtp(data).subscribe(
          (res: any) => {
            this.helperMethod.hideSpinner();
            this.clickToggleLogin('login_card_id');
            this.clickToggleLogin('loginUser_card_id');
            this.helperMethod.presentToastr('Otp has created');
            this.UserLoginRequest.controls['otp'].setValidators([
              Validators.required,
            ]);
            this.isOTPRequested = true;
          },
          (err) => {
            this.helperMethod.hideSpinner();
            this.clickToggleLogin('login_card_id');
            this.clickToggleLogin('loginUser_card_id');
            if (err.error.non_field_errors) {
              this.helperMethod.presentToastr(err.error.non_field_errors[0]);
            } else {
              this.helperMethod.presentToastr('Something went wrong');
            }
          }
        );
      }
    }
  }

  resetOtp() {
    this.isOTPRequested = true;
    this.UserLoginRequest.controls['otp'].setValidators([]);
  }

  resendSMS() {
    this.helperMethod.presentSpinner();
    this._auth
      .requestLoginOtp({ phone: this.UserLoginRequest.controls['phone'].value })
      .subscribe(
        (res: any) => {
          this.helperMethod.hideSpinner();
          this.isOTPRequested = true;
          this.helperMethod.presentToastr('Otp code has been resent');
          this.UserLoginRequest.controls['otp'].setValidators([
            Validators.required,
          ]);
        },
        (err) => {
          this.helperMethod.hideSpinner();
          if (navigator.onLine && err.status != 401) {
            if (err && err.error && err.error.email && !err.error.name) {
              this.helperMethod.presentToastr(err.error.email[0]);
            } else if (err && err.error && err.error.name && !err.error.email) {
              this.helperMethod.presentToastr(err.error.name[0]);
            } else if (err && err.error && err.error.name && err.error.email) {
              this.helperMethod.presentToastr(err.error.email[0]);
            } else if (err && err.error && err.error.phone && err.error.phone) {
              this.helperMethod.presentToastr(err.error.phone[0]);
            } else {
              this.helperMethod.presentToastr('Failed to sign up.');
            }
          }
        }
      );
  }
}
